@if (!readOnly) {
  <div class="trade-attachments-input-container pt-2">
    <mat-form-field
      class="pe-2 {{ rights.includes('CMUploadFiles') ? 'w-50' : 'w-100' }}"
    >
      <mat-label>Enter Notes Here</mat-label>
      <textarea
        matInput
        [placeholder]="'Enter Notes Here'"
        [(ngModel)]="note"
      ></textarea>
    </mat-form-field>

    @if (rights.includes('CMUploadFiles')) {
      <div class="upload-case-files mb-3 w-50 ps-2">
        <h4 class="mb-2"> Upload Case Files </h4>
        <input
          #fileUpload
          type="file"
          class="file-input"
          (change)="onFileSelected($event)"
        />
        <span class="mb-2">
          {{ fileName || 'No file selected yet' }}
        </span>
        @if (!fileName) {
          <button
            type="button"
            class="w-100"
            mat-stroked-button
            aria-label="Attach File"
            color="primary"
            (click)="fileUpload.click()"
          >
            <mat-icon>attach_file</mat-icon> Attach File
          </button>
        } @else {
          <button
            type="button"
            class="w-100 mb-3"
            mat-stroked-button
            aria-label="Choose a Different File"
            (click)="fileUpload.click()"
          >
            <mat-icon>upload</mat-icon> Choose a Different File
          </button>
          <button
            type="button"
            class="w-100 mb-3"
            mat-button
            aria-label="Remove File"
            color="warn"
            (click)="clearFile()"
          >
            <mat-icon>clear</mat-icon> Remove File
          </button>
        }
      </div>
    }
  </div>

  <div class="save-button-container mb-3">
    <button
      type="button"
      class="w-100 save-buton"
      mat-raised-button
      color="accent"
      [disabled]="!note && !fileName"
      (click)="save()"
    >
      <mat-icon>save</mat-icon>Save
    </button>
  </div>
}

@if (tradeAttachments) {
  <div class="attached-files mb-2">
    <table>
      <thead>
        <tr>
          @for (col of caseFileCols; track col.label) {
            <th>{{ col.label }}</th>
          }
        </tr>
      </thead>
      <tbody>
        @if (tradeAttachments && tradeAttachments.length > 0) {
          @for (tradeAttachment of tradeAttachments; track tradeAttachment) {
            <tr>
              @for (col of caseFileCols; track col.label) {
                <td>
                  <span class="attachment-container">
                    @if (col.varName === 'CreateDate') {
                      {{ tradeAttachment[col.varName] | date: 'shortDate' }}
                    } @else {
                      {{ tradeAttachment[col.varName] }}
                    }
                    @if (tradeAttachment.Location && col.varName === 'Name') {
                      <button
                        type="button"
                        mat-icon-button
                        color="primary"
                        matTooltip="Download File"
                        (click)="downloadAttachment(tradeAttachment)"
                      >
                        <mat-icon>download</mat-icon>
                      </button>
                    }
                  </span>
                </td>
              }
            </tr>
          }
        } @else {
          <tr class="no-data">
            <td colspan="4" class="no-results"> No data </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
